import React, { useEffect, useState, useContext } from "react";
import { ParentPortal, GirlAvatar, Kids } from "@app/assets";
import { Icon, Input, Layout } from "@app/components";
import { ButtonHolder, ButtonLink, FlexWrapper, Error, EmptyContainer, DefaultMessage, FormHeader, FormTitle } from "@app/components/commonStyles";
import { useForm } from "react-hook-form";
import { AuthContext, baseUrl, webflowUrl, gameBaseUrl } from "@app/providers";
import { useLocation, KadooPattern } from "@app/utils";
import { updateUser, saveAvatarName, getAvatarName } from "@app/services";
import { PopUpContainer, PopUpSubTitle, PopUpTitle, PopUpWrapper } from "@app/components/success-modal/success-modal-components";
import { Label } from "@app/components/input/input-components";

export default function ParentPortalLayout() {
  const { userInfo }: any = useContext(AuthContext);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [first, setFirst] = useState<any>(localStorage.getItem("first"))
  const [last, setLast] = useState<any>(localStorage.getItem("last"))
  const [instructionfail, setInstrctionfail] = useState(false)
  const userToken = userInfo && userInfo.sessionToken;
  const { navigate } = useLocation();
  const {
    register,
    errors
  }: any = useForm({});
  const [minErr, showMinErr] = useState(false)
  const [MaxErr, showMaxErr] = useState(false)
  const [specialPatt, showSpecialPatt] = useState(false)
  const [kadooUserName, setKadoouserName] = useState("")
  const [specialCharErr, showSpecialCharErr] = useState(false)
  const [instructionsToPlay, setInstructionsToPlay] = useState(false)
  const [playGameLinkEnable, setPlayGameLinkEnable] = useState(false)
  const [kadooName, setKadooName] = useState()
  const [avatarName, setAvatarName] = useState("")

  useEffect(() => {
    // if (userToken && (userInfo.userJson.userType === "parent" || userInfo.userJson.userType === "educator")) {
    //   navigate('/pagenotfound')
    // }
    if (userInfo && userInfo.userJson.kadooName) {
      setBtnDisabled(false)
      setKadoouserName(userInfo.userJson.kadooName)
    }
    getAvatarNameValue()

  }, [])

  function PlayNowBtn() {
    if (getUA() === 'Android') {
      window.location.replace("https://play.google.com/store/apps/details?id=com.KazooBadoo.KazooBadoo")
      // intent://beta.kazoobadoo.com/#Intent;scheme=https;package=com.KazooBadoo.KazooBadoo;end
    } else if (getUA() === "Windows") {
      window.open(baseUrl + 'WebGL/index.html', '_blank')
    } else if (getUA() === "iPhone") {

      appleDevice()
      // window.location.replace("https://apps.apple.com/us/app/kazoobadoo/id1612396303")
    } else if (getUA() === "macOS" && navigator.maxTouchPoints >= 0) {
      appleDevice()
      // window.location.replace("https://apps.apple.com/us/app/kazoobadoo/id1612396303")
    } else if (getUA() === 'Unknown') {
      playNow()
    }
  }

  function PlayGameNowBtn() {
    setPlayGameLinkEnable(true)
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
      avatarName: kadooUserName
    });
    saveAvatarName(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          return response;
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  function getAvatarNameValue() {
    setPlayGameLinkEnable(false)
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
    });
    getAvatarName(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          setBtnDisabled(false)
          setAvatarName(response.avatarName);
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  function ContinuePlayNowBtn() {
    window.open(gameBaseUrl, '_blank')
  }

  function appleDevice() {
    // window.location.replace("instagram://");
    window.location.replace("https://apps.apple.com/us/app/kazoobadoo/id1612396303");
    // setTimeout(() => {
    //   window.location.replace("https://apps.apple.com/us/app/instagram/id389801252");
    // }, 1000);
    // var app = {
    //   launchApp: function () {
    //     window.location.replace("https://apps.apple.com/us/app/kazoobadoo/id1612396303");
    //     setTimeout(() => {
    //       openWebApp()
    //     }, 1000)
    //   },
    // };
    // app.launchApp();
  }

  function openWebApp() {
    window.location.replace("https://apps.apple.com/us/app/kazoobadoo/id1612396303");
  }

  function playNow() {
    setInstructionsToPlay(true)
    const Link = "https://drive.google.com/drive/folders/1cDGftiP1hXZFs9RzkbA0SH60IuesGdTB"

    if (userInfo && userInfo.userJson.kadooName !== kadooUserName) {
      const params: any = {
        sessionToken: userInfo && userInfo.sessionToken,
        userId: userInfo && userInfo.userJson.userId,
        kadooName: kadooUserName
      }
      updateUser(params)
        .then((resp: any) => {
          const response = resp;
          if (response._responseStatus === 1) {
            // window.open(Link,"_blank")
            setKadooName(response.userJson.kadooName)
            setInstructionsToPlay(true)
          }
        })
    } else {
      // window.open(Link,"_blank")
    }
  }
  const getUA = () => {
    let device = "Unknown";
    const ua: any = {
      "Android": /Android/i,
      "Chrome OS": /CrOS/i,
      "iPad": /iPad/i,
      "iPhone": /iPhone/i,
      // "iPod": /iPod/i,
      "macOS": /Macintosh/i,
      "Windows": /IEMobile|Windows/i,
    }
    Object.keys(ua).map(v => navigator.userAgent.match(ua[v]) && (device = v));
    return device;
  }

  function handleKadooName(evt: any) {
    showSpecialCharErr(false)
    setKadoouserName(evt.target.value)
    showMinErr(false)
    showMaxErr(false)
    showSpecialPatt(false)
    setInstrctionfail(false)

    if (evt.target.value.trim() || userInfo.userJson.kadooName) {
      setBtnDisabled(false)
    }
    else if (evt.target.value.trim() === "") {
      setBtnDisabled(true)
      setInstrctionfail(false)
    } else if (evt.target.value.length == 0) {
      setBtnDisabled(true)
      setInstrctionfail(false)
    }

    let Avthar = evt.target.value.trim()
    if ((Avthar.replace().toUpperCase() && Avthar.toLowerCase()).match(first)) {
      setInstrctionfail(true)
      setBtnDisabled(true)
    } else if ((Avthar.toUpperCase() && Avthar.toLowerCase().match(last))) {
      setInstrctionfail(true)
      setBtnDisabled(true)
    }
    else if ((Avthar.toUpperCase().split("") && Avthar.toLowerCase() === (first.split("")))) {
      setInstrctionfail(true)
      setBtnDisabled(true)
    }
    else if (Avthar.length > 0 && Avthar.length < 4 && Avthar.length == 0) {
      showMinErr(true)
      setBtnDisabled(true)
    } else if (Avthar.length > 0 && Avthar.length < 4) {
      setBtnDisabled(true)
    }
    else if (Avthar.length > 12) {
      showMaxErr(true)
      setBtnDisabled(true)
    } else if (KadooPattern.test(evt.target.value)) {
      showSpecialCharErr(true)
      setBtnDisabled(true)
    }
    else {
      // setBtnDisabled(false)
    }

  }

  function linkRedirection() {
    window.open(webflowUrl + "company/support")
  }

  function PortalRedirection() {
    navigate("/profile")
  }

  return (
    <>
      <Layout className="aligned-center">
        <FormHeader className="mb-3">
          <span style={{ cursor: "pointer" }} className="back-icon" onClick={() => PortalRedirection()}>
            <Icon name="backArrow" />
          </span>
          <FormTitle className="justify-center">
            <h3 className="primary-header text-center play-header">
              Ready to play
        </h3>
          </FormTitle>
        </FormHeader>
        <FlexWrapper className="align-center mt-3">
          <FlexWrapper className="w-200 justify-center">
            <img alt="" src={GirlAvatar} />
          </FlexWrapper>
          <FlexWrapper className="w-300 centered col-layout">
            <FlexWrapper className="col-layout mb-4">
              <Label>Name Your Avatar</Label>
              {avatarName &&  
              <Input
                placeholder="Kadoo Name (Name your Avatar)"
                name="kadooName"
                type="text"
                className="w-100 mb-0"
                onChange={handleKadooName}
                value={avatarName}
                minLength={4}
                showInstructions={true}
                instructions="Kadoo Name cannot include any part of your real name"
                instructionFailed={instructionfail}
              />
              }
              {!avatarName &&  
              <Input
                placeholder="Kadoo Name (Name your Avatar)"
                name="kadooName"
                type="text"
                className="w-100 mb-0"
                onChange={handleKadooName}
                minLength={4}
                showInstructions={true}
                instructions="Kadoo Name cannot include any part of your real name"
                instructionFailed={instructionfail}
              />
              }
              
              {minErr && <Error>Must be atleast 4 characters</Error>}
              {MaxErr && <Error>Max 12 characters are allowed</Error>}
              {specialCharErr && <Error>Special characters are not allowed</Error>}
              {/* {specialPatt && <Error>Special Characters are not allowed</Error>} */}
            </FlexWrapper>
            <ButtonHolder style={{ cursor: "pointer" }} className={btnDisabled ? 'disabled' : ''}>
              <ButtonLink onClick={PlayGameNowBtn}>Play Now</ButtonLink>
            </ButtonHolder>
          </FlexWrapper>
        </FlexWrapper>
      </Layout>
      {playGameLinkEnable &&
      <PopUpWrapper>
        <PopUpContainer className="alt-padding">
          <h3 className="primary-header text-center mb-3">Play KazooBadoo</h3>
          <span className="close-icon" onClick={() => setPlayGameLinkEnable(false)}>
            <Icon name="close" />
          </span>
          <img alt="Kazoo Badoo" src={Kids} />
          <span className="small-font mt-30" style={{fontFamily:"filson"}}>Click <a onClick={ContinuePlayNowBtn} target="_blank" style={{ cursor: "pointer", color: "var(--kazoobadooTeal)"}} className={btnDisabled ? 'disabled' : ''}>here</a> to play in browser </span>
          <span className="small-font mt-30" style={{fontFamily:"filson"}}>Click  <a onClick={PlayNowBtn} target="_blank" style={{ cursor: "pointer", color: "var(--kazoobadooTeal)"}} className={btnDisabled ? 'disabled' : ''}>here</a> to download the app</span>
        </PopUpContainer>
      </PopUpWrapper>
      }
      {instructionsToPlay &&
        <PopUpWrapper>
          <PopUpContainer className="alt-padding">
            <h3 className="primary-header text-center mb-3">KazooBadoo Game</h3>
            <span className="close-icon" onClick={() => setInstructionsToPlay(false)}>
              <Icon name="close" />
            </span>
            <img alt="Kazoo Badoo" src={Kids} />
            <PopUpSubTitle>
              {getUA() === "Unknown" ?
                <>Currently we do not support KazooBadoo on your device. Please connect with a supported device.<span className="anchor-tag" onClick={() => linkRedirection()}> See our FAQ for a list of supported devices.</span></>
                : "Coming Soon!"}
            </PopUpSubTitle>
          </PopUpContainer>
        </PopUpWrapper>
      }
    </>
  );
}